
import { motion } from 'framer-motion';

const AdvantageSection = () => {
  const advantages = [
    {
      title: '16个国家级市场试点',
      description: '广州拥有全国最多的市场采购贸易试点市场，覆盖服装、鞋类、箱包、家居等多个品类',
    },
    {
      title: '白云区政策优势',
      description: '作为广州市场采购贸易核心区域，享受最优惠的政策支持和最便捷的通关服务',
    },
    {
      title: '天健广场服务基地',
      description: '一站式服务中心，提供政策咨询、系统培训、业务办理等全方位支持',
    },
    {
      title: '数字化系统支撑',
      description: '自主研发的1039数字化平台，实现从备案到结汇的全流程线上操作',
    },
  ];

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Wave Divider */}
      <div className="absolute top-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" className="w-full h-auto">
          <path
            fill="#F5F7FA"
            d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
          ></path>
        </svg>
      </div>

      <div className="max-w-[1440px] mx-auto px-8 pt-12">
        <div className="grid grid-cols-12 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="col-span-5"
          >
            <div className="inline-flex items-center gap-2 mb-4">
              <div className="w-3 h-3 bg-accent rotate-45"></div>
              <span className="text-accent text-sm font-semibold uppercase tracking-wider whitespace-nowrap">广州优势</span>
            </div>

            <h2 className="text-4xl font-bold text-primary mb-8">
              为什么选择<br />广州白云
            </h2>

            <div className="space-y-6">
              {advantages.map((advantage, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="flex gap-4"
                >
                  <div className="flex-shrink-0 w-3 h-3 rounded-full bg-accent mt-2"></div>
                  <div>
                    <h3 className="text-lg font-bold text-primary mb-2">
                      {advantage.title}
                    </h3>
                    <p className="text-neutral-500 leading-relaxed">
                      {advantage.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="mt-8 px-8 py-4 bg-primary text-white font-semibold rounded-lg hover:bg-primary-dark transition-all duration-300 flex items-center gap-2 cursor-pointer whitespace-nowrap"
            >
              查看试点政策
              <i className="ri-arrow-right-line"></i>
            </motion.button>
          </motion.div>

          {/* Right Map */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="col-span-7"
          >
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/2b0a8a2d1e42c73ef57ecaf4ea640069.jpg"
                alt="广州白云区市场分布图"
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
              
              {/* Floating Info Cards */}
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="absolute top-8 right-8 bg-white rounded-xl p-4 shadow-xl"
              >
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-accent/20 flex items-center justify-center">
                    <i className="ri-map-pin-fill text-2xl text-accent"></i>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-primary">16</div>
                    <div className="text-xs text-neutral-500 whitespace-nowrap">试点市场</div>
                  </div>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.7 }}
                className="absolute bottom-8 left-8 bg-white rounded-xl p-4 shadow-xl"
              >
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center">
                    <i className="ri-building-fill text-2xl text-primary"></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-primary whitespace-nowrap">天健广场</div>
                    <div className="text-xs text-neutral-500 whitespace-nowrap">服务基地</div>
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AdvantageSection;
